import { type SearchRequest } from '@searchkit/api';
import { merge } from 'merge-anything';

import { mainLinePriorityQuery } from '~/search-domain/queries';
import { mergeQueries } from '~/search-domain/utils';

type ExtendedSearchRequest = SearchRequest & {
  facet?: string;
  type?: 'facet';
};

export function createQueryFactory() {
  return (searchRequest: ExtendedSearchRequest): SearchRequest => {
    const { hitsPerPage = 1 } = searchRequest.request.params ?? {};

    return merge(searchRequest, {
      body: {
        query: mergeQueries(searchRequest.body?.query ?? {}, mainLinePriorityQuery),
        size: hitsPerPage,
        aggs: {
          market_names: {
            terms: { field: 'marketDisplayName', size: 100 },
          },
          market_names_map_uk: {
            terms: { field: 'marketDisplayNameMap.uk.keyword', size: 100 },
          },
          market_names_map_us: {
            terms: { field: 'marketDisplayNameMap.us.keyword', size: 100 },
          },
          market_names_map_gz: {
            terms: { field: 'marketDisplayNameMap.gz.keyword', size: 100 },
          },
        },
        sort: [
          { 'line.main': { order: 'desc', missing: '_last' } },
          { 'line.sign': { order: 'asc', missing: '_last' } },
          { oddsDecimal: { order: 'desc', missing: '_last' } },
          { subeventStartTime: { order: 'asc' } },
        ],
      },
    });
  };
}
